"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useIframeOrigin = void 0;
var _react = require("react");
const useIframeOrigin = () => {
  const [isSameOrigin, setIsSameOrigin] = (0, _react.useState)(false);
  const [isIframe, setIsIframe] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    try {
      if (window.self === window.top) {
        setIsSameOrigin(false);
        setIsIframe(false);
      } else {
        setIsIframe(true);
        // will throw if cross-origin
        void window.parent.location.href;
        setIsSameOrigin(true);
      }
    } catch (e) {
      setIsSameOrigin(false);
    }
  }, []);
  return {
    isSameOrigin,
    isIframe
  };
};
exports.useIframeOrigin = useIframeOrigin;